module.exports = __webpack_public_path__ + "static/media/29COICT7.b89d096b.jpg";